module.exports = __webpack_public_path__ + "media/115.b9467ba6.wav";